module.exports=/[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/


//////////////////
// WEBPACK FOOTER
// /usr/src/app/~/uc.micro/categories/Z/regex.js
// module id = 388
// module chunks = 168707334958949